/* Kanadeal — bouton "Mes points" : menu burger (avec solde) + fiche produit + panier. Lien -> /pages/mes-points */
(function(){
  if(window.__kdPointsLinksInit) return;
  window.__kdPointsLinksInit=true;
  var URL='/pages/mes-points';
  function balLabel(){
    var M=window.KD_MEMBER||{};
    var p=(typeof M.points==='number'&&isFinite(M.points))?M.points:null;
    if(M.loggedIn && p!=null){ try{return p.toLocaleString('fr-FR')+' pts';}catch(e){return p+' pts';} }
    return null;
  }
  function injectMenu(){
    document.querySelectorAll('.menu-drawer').forEach(function(drawer){
      var existing=drawer.querySelector('.kdpl-menu');
      var bal=balLabel();
      if(existing){
        var b=existing.querySelector('.kdpl-menu__bal');
        if(b){ if(bal){ b.textContent=bal; b.className='kdpl-menu__bal'; } else { b.textContent='Voir →'; b.className='kdpl-menu__bal kdpl-menu__bal--cta'; } }
        return;
      }
      var cats=drawer.querySelector('.kd-menu-cats');
      var anchor=cats||drawer.querySelector('.menu-drawer__top-cta')||drawer.querySelector('.menu-drawer__search-bar')||drawer.querySelector('.menu-drawer__navigation');
      if(!anchor||!anchor.parentNode) return;
      var right=bal?('<span class="kdpl-menu__bal">'+bal+'</span>'):'<span class="kdpl-menu__bal kdpl-menu__bal--cta">Voir →</span>';
      var wrap=document.createElement('div'); wrap.className='kdpl-menu-wrap';
      wrap.innerHTML='<a class="kdpl-menu" href="'+URL+'"><span class="kdpl-menu__l"><span class="kdpl-menu__ic">⚡</span><span class="kdpl-menu__txt">Mes points fidélité</span></span>'+right+'</a>';
      anchor.parentNode.insertBefore(wrap, anchor);
    });
  }
  function btnHTML(cls){
    var bal=balLabel();
    var b=bal?(' <span class="kdpl-btn__bal">· '+bal+'</span>'):'';
    return '<a class="kdpl-btn '+cls+'" href="'+URL+'"><span class="kdpl-btn__ic">⚡</span><span class="kdpl-btn__txt">Consulter mes points'+b+'</span></a>';
  }
  function injectProduct(){
    var main=document.querySelector('main[data-template="product"]'); if(!main||main.querySelector('.kdpl-prod')) return;
    var box=main.querySelector('.kdpp'); if(!box||!box.parentNode) return;
    var el=document.createElement('div'); el.className='kdpl-prod'; el.innerHTML=btnHTML('kdpl-btn--prod');
    box.parentNode.insertBefore(el, box.nextSibling);
  }
  function injectCart(){
    document.querySelectorAll('.cart-drawer').forEach(function(drawer){
      if(drawer.querySelector('.kdpl-cart')) return;
      var el=document.createElement('div'); el.className='kdpl-cart kdpl-cart--top'; el.innerHTML=btnHTML('kdpl-btn--cart');
      var header=drawer.querySelector('.cart-drawer__header');
      if(header && header.parentNode){ header.parentNode.insertBefore(el, header.nextSibling); }
      else { drawer.insertBefore(el, drawer.firstChild); }
    });
    document.querySelectorAll('.cart__ctas').forEach(function(ctas){
      if(ctas.closest('.cart-drawer')) return;
      var summary=ctas.parentNode; if(!summary||summary.querySelector('.kdpl-cart')) return;
      var el=document.createElement('div'); el.className='kdpl-cart'; el.innerHTML=btnHTML('kdpl-btn--cart');
      summary.insertBefore(el, ctas);
    });
  }
  function run(){ injectMenu(); injectProduct(); injectCart(); }
  var t=null; function schedule(){ if(t)return; t=setTimeout(function(){t=null;run();},150); }
  function init(){ run(); [300,900,1800,3000].forEach(function(d){setTimeout(run,d);});
    try{ new MutationObserver(schedule).observe(document.documentElement,{childList:true,subtree:true}); }catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
